/* Borrow Luxury redesign: nav, tabs, accordions, hotspot, waitlist flow, fitting form. No dependencies. */
(function () {
  'use strict';
  var d = document;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  var isTouch = window.matchMedia('(hover: none)').matches;

  /* Header: collection dropdown (hover, 180ms close delay) and hamburger */
  qsa('.bl-dd').forEach(function (dd) {
    var t;
    dd.addEventListener('mouseenter', function () { clearTimeout(t); dd.classList.add('is-open'); });
    dd.addEventListener('mouseleave', function () { t = setTimeout(function () { dd.classList.remove('is-open'); }, 180); });
    var trig = qs('.bl-dd__trigger', dd);
    if (trig) trig.addEventListener('click', function (e) {
      if (isTouch) { e.preventDefault(); dd.classList.toggle('is-open'); }
    });
  });
  qsa('.bl-burger').forEach(function (b) {
    b.addEventListener('click', function () {
      var h = b.closest('.bl-header');
      var open = h.classList.toggle('menu-open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* Occasion tabs */
  qsa('[data-bl-tabs]').forEach(function (root) {
    var tabs = qsa('.bl-tab', root), panels = qsa('.bl-panel', root), title = qs('[data-bl-tab-title]', root), viewAll = qs('[data-bl-tab-link]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === tab); x.setAttribute('aria-selected', x === tab ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === key); });
        if (title) title.textContent = tab.getAttribute('data-title') || '';
        if (viewAll && tab.getAttribute('data-url')) viewAll.setAttribute('href', tab.getAttribute('data-url'));
      });
    });
  });

  /* Accordions: one open at a time per group */
  qsa('[data-bl-accordion]').forEach(function (group) {
    qsa('.bl-acc__q', group).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.bl-acc'), open = item.classList.contains('is-open');
        qsa('.bl-acc', group).forEach(function (i) { i.classList.remove('is-open'); qs('.bl-acc__mark', i).textContent = '+'; qs('.bl-acc__q', i).setAttribute('aria-expanded', 'false'); });
        if (!open) { item.classList.add('is-open'); qs('.bl-acc__mark', item).textContent = '−'; btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  });

  /* Hero hotspot: hover on desktop, tap on mobile */
  qsa('.bl-spot').forEach(function (spot) {
    var dot = qs('.bl-spot__dot', spot);
    spot.addEventListener('mouseenter', function () { if (!isTouch) spot.classList.add('is-open'); });
    spot.addEventListener('mouseleave', function () { if (!isTouch) spot.classList.remove('is-open'); });
    dot.addEventListener('click', function (e) { e.preventDefault(); spot.classList.toggle('is-open'); });
  });
  d.addEventListener('click', function (e) {
    if (!e.target.closest('.bl-spot')) qsa('.bl-spot.is-open').forEach(function (s) { s.classList.remove('is-open'); });
  });

  /* Waitlist flow: 0 none, 1 quick form, 2 founding year offer, 3 confirmation */
  var flow = {
    form: qs('#bl-waitlist-form'), offer: qs('#bl-waitlist-offer'), done: qs('#bl-waitlist-done'),
    firstName: '', email: '', tier: '',
    close: function () { [this.form, this.offer, this.done].forEach(function (m) { if (m) m.classList.remove('is-open'); }); d.body.style.overflow = ''; },
    open: function (step) {
      this.close();
      var m = step === 1 ? this.form : step === 2 ? this.offer : this.done;
      if (!m) return;
      m.classList.add('is-open'); d.body.style.overflow = 'hidden';
      var f = qs('input', m); if (f && step === 1) setTimeout(function () { f.focus(); }, 60);
    }
  };
  window.BLWaitlist = flow;

  function subscribeToKlaviyo(payload) {
    /* TODO (store owner): add the Klaviyo public key and list ID in the BL Header section settings, or set window.BL_KLAVIYO = { publicKey: 'XXXXXX', listId: 'YYYYYY' } before this script runs. */
    var k = window.BL_KLAVIYO || {};
    if (!k.publicKey || !k.listId) { if (window.console) console.info('Borrow Luxury waitlist: Klaviyo not configured yet', payload); return Promise.resolve(); }
    var body = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: payload.email, first_name: payload.firstName || undefined, properties: payload.properties || {} } } }, custom_source: payload.source || 'Website waitlist' }, relationships: { list: { data: { type: 'list', id: k.listId } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.publicKey), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' }, body: JSON.stringify(body)
    }).catch(function () {});
  }

  d.addEventListener('click', function (e) {
    var el = e.target.closest('[data-bl-waitlist]');
    if (el) {
      e.preventDefault();
      var mode = el.getAttribute('data-bl-waitlist');
      flow.open(mode === 'offer' ? 2 : 1);
      return;
    }
    if (e.target.closest('[data-bl-close]')) { e.preventDefault(); flow.close(); return; }
    var reserve = e.target.closest('[data-bl-reserve]');
    if (reserve) {
      e.preventDefault();
      flow.tier = reserve.getAttribute('data-bl-reserve');
      var slot = qs('[data-bl-chosen-tier]'); if (slot) slot.textContent = flow.tier;
      if (flow.email) subscribeToKlaviyo({ email: flow.email, firstName: flow.firstName, source: 'Founding Year reservation', properties: { founding_year_tier: flow.tier } });
      flow.open(3);
      return;
    }
  });
  qsa('.bl-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m) flow.close(); });
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') flow.close(); });

  var quick = qs('#bl-waitlist-form form');
  if (quick) quick.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = qs('[name="first_name"]', quick).value.trim(), email = qs('[name="email"]', quick).value.trim(), err = qs('.bl-error', quick);
    if (!name || !/.+@.+\..+/.test(email)) { err.hidden = false; return; }
    err.hidden = true; flow.firstName = name; flow.email = email;
    subscribeToKlaviyo({ email: email, firstName: name, source: 'Membership waitlist' });
    flow.open(2);
  });

  /* Inline email-only forms (home "Join the list", membership "Join the waitlist") */
  qsa('[data-bl-inline-waitlist]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = qs('[name="email"]', f).value.trim(), btn = qs('button', f);
      if (!/.+@.+\..+/.test(email)) { qs('[name="email"]', f).focus(); return; }
      flow.email = email;
      subscribeToKlaviyo({ email: email, source: f.getAttribute('data-bl-inline-waitlist') || 'Website list' });
      if (btn) btn.textContent = btn.getAttribute('data-done') || 'On the list';
      if (f.hasAttribute('data-bl-then-offer')) flow.open(2);
    });
  });

  /* Fitting request modal (Shopify contact form inside) */
  var fit = qs('#bl-fitting');
  if (fit) {
    var openFit = function (e) { if (e) e.preventDefault(); fit.classList.add('is-open'); d.body.style.overflow = 'hidden'; };
    var closeFit = function () { fit.classList.remove('is-open'); d.body.style.overflow = ''; };
    qsa('[data-bl-fitting]').forEach(function (b) { b.addEventListener('click', openFit); });
    qsa('[data-bl-fitting-close]', fit).forEach(function (b) { b.addEventListener('click', closeFit); });
    fit.addEventListener('click', function (e) { if (e.target === fit) closeFit(); });
    var ff = qs('form', fit);
    if (ff) ff.addEventListener('submit', function (e) {
      var missing = qsa('[required]', ff).some(function (i) { return !i.value.trim(); });
      var err = qs('.bl-error', ff);
      if (missing) { e.preventDefault(); if (err) err.hidden = false; } else if (err) { err.hidden = true; }
    });
    if (window.BL_FITTING_SENT || location.hash === '#bl-fitting-sent') openFit();
  }
})();
